"use strict";

(() => {
  const root = document.documentElement;
  const header = document.querySelector(".p-header");

  if (root.classList.contains("is-loading") && header) {
    const drawerIcon = document.querySelector(".p-drawer__icon");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const showHeader = () => {
      header.classList.add("is-headerIn");

      if (drawerIcon) {
        drawerIcon.classList.add("is-headerIn");
      }
    };

    document.addEventListener(
      "theme:fvStart",
      () => {
        if (reduce) {
          showHeader();
          return;
        }

        // transition 開始前に退避位置を描画
        requestAnimationFrame(() => {
          requestAnimationFrame(showHeader);
        });
      },
      { once: true }
    );
  }
})();
